module.exports = __webpack_public_path__ + "img/verify_status_success.b378a6e0.svg";